var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgEmerald(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.7359V50.2639C16 52.3068 16.8302 54.2631 18.2956 55.6852L31.6285 68.6284C33.5199 70.4619 36.5228 70.4619 38.4069 68.6284L51.7399 55.6852C53.2053 54.2631 54.0355 52.3068 54.0355 50.2639V19.7359C54.0355 17.693 53.2053 15.7368 51.7399 14.3147L38.4069 1.37151C36.5156 -0.462051 33.5126 -0.462051 31.6285 1.37151L18.2956 14.3147C16.8302 15.7368 16 17.693 16 19.7359Z",
    fill: "#7DC64E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0227 20.2557L36.429 0.923997C36.1619 0.382593 35.6277 0.00721873 35.0286 0C35.0214 0 35.0142 0 35.0069 0C34.4078 0 33.8736 0.382593 33.6065 0.916778L24.0128 20.2557H46.0227Z",
    fill: "#C2F366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4508 16.8124L46.0299 20.2485L53.7539 52.2852C53.8406 51.9892 53.8983 51.6788 53.9489 51.3684C53.9561 51.3179 53.9633 51.2746 53.9705 51.224C54.0138 50.9064 54.0427 50.5816 54.0427 50.2567V19.736C54.0355 18.7253 53.8334 17.7292 53.4508 16.8124Z",
    fill: "#47AA54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2126 16.3287L46.0227 20.2557L53.754 52.2852C53.8406 51.9892 53.8983 51.6788 53.9489 51.3756C53.9489 51.354 53.9561 51.3323 53.9561 51.3179C53.9633 51.289 53.9633 51.2602 53.9705 51.2313C54.0138 50.9137 54.0427 50.5888 54.0427 50.264V19.736C54.0355 18.5377 53.7467 17.3755 53.2126 16.3287Z",
    fill: "#47AA54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2126 16.3287C52.8372 15.5924 52.3463 14.9066 51.7399 14.3147L50.585 13.1886L50.1879 12.806C49.4949 12.1346 48.3255 12.4378 48.0512 13.369L46.0155 20.2557L53.2126 16.3287Z",
    fill: "#47AA54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8229 16.3287C17.1982 15.5924 17.6891 14.9066 18.2955 14.3147L19.4505 13.1886L19.8475 12.806C20.5405 12.1346 21.7027 12.4378 21.9843 13.369L24.0199 20.2557L16.8229 16.3287Z",
    fill: "#47AA54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7977 17.1011C52.6928 16.6103 52.8588 15.3975 52.1297 14.6901L51.7472 14.3147L50.5922 13.1886L50.1951 12.806C49.5021 12.1346 48.3327 12.4378 48.0584 13.369L46.0227 20.2557L51.7977 17.1011Z",
    fill: "#7DC64E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2378 17.1011C17.3427 16.6103 17.1767 15.3975 17.9058 14.6901L18.2884 14.3147L19.4434 13.1886L19.8404 12.806C20.5334 12.1346 21.6956 12.4378 21.9771 13.369L24.0128 20.2557L18.2378 17.1011Z",
    fill: "#7DC64E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8229 16.3287L24.0128 20.2557L16.2815 52.2852C16.1949 51.9892 16.1372 51.6788 16.0866 51.3756C16.0866 51.354 16.0794 51.3323 16.0794 51.3179C16.0794 51.2818 16.0722 51.2529 16.0722 51.2241C16.0289 50.9064 16 50.5888 16 50.264V19.736C16 18.5377 16.2887 17.3755 16.8229 16.3287Z",
    fill: "#47AA54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3208 53.4619H35.0214V68.0365C35.0214 69.1843 36.2269 69.9928 37.2447 69.473C37.6634 69.2565 38.0532 68.9822 38.4069 68.6357L51.7399 55.6925C52.4113 55.0428 52.931 54.2776 53.3208 53.4619Z",
    fill: "#47AA54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2342 53.6279C53.4508 53.1948 53.624 52.7472 53.754 52.2852L46.0227 20.2557L35.0214 57.4827L53.2342 53.6279Z",
    fill: "#97D757"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0214 57.4826V63.864C35.0214 64.7808 36.1186 65.2428 36.7755 64.6075L43.7199 57.8652C44.5645 57.0423 43.8138 55.6274 42.6588 55.8656L35.0214 57.4826Z",
    fill: "#2A9254"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2815 52.2852C16.4114 52.7472 16.5847 53.1948 16.8012 53.6279L35.0213 57.4827L24.0128 20.2557L16.2815 52.2852Z",
    fill: "#B1E860"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0128 20.2557L35.0214 57.4827L46.0227 20.2557H24.0128Z",
    fill: "#FEFFC2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0501 44.9726L16.2815 52.2852C16.4114 52.7472 16.5847 53.1948 16.8012 53.6279L19.5371 54.2054L21.0531 54.5302C22.0565 54.7396 22.9227 53.8084 22.6268 52.8266L20.2951 44.9149C19.9558 43.7743 18.3244 43.8176 18.0501 44.9726Z",
    fill: "#E5F999"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0371 20.2556L49.2495 18.5015C49.7115 18.2488 49.5382 17.5703 49.0762 17.2887L44.5934 13.7588C43.7705 13.1019 42.9187 13.7877 43.2363 14.6395L46.0371 20.2556Z",
    fill: "#2A9254"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.8d657671.svg";
export { ForwardRef as ReactComponent };